(function($){
    $.ComponentType = class extends Emitter {
        static _subcomponents = [];
        static _component_name = null;

        constructor(options) {
            super();
            this._subcomponents_instances = [];
            this._subcomponents_state = [];
            
            this._component_ready = false;

            this._options = options || {};
            this.parent = null;
            this.root_component = null;
        }

        static _add_child_component(child_type) {
            this._subcomponents.push(child_type);
        }

        /**
         * Returns the stored root component, if not set it is searched recursively
         * @returns ABDOMap.ComponentType
         */
        _get_root() {
            if (this.root_component == null) {
                if (this.parent === null) {
                    return this;
                }
                else {
                    return this.parent._get_root();
                }
            }
            else {
                return this.root_component;
            } 
        } 

        _is_ready() {
            return new Promise(function(resolve, reject){
                if (this._component_ready) {
                    resolve(true);
                } else {
                    this._once("ready", function(){
                        resolve(true);
                    });
                }
            }.bind(this));
        }

        _set_ready() {
            this._component_ready = true;
            this._emit("ready");
        }

        async _initialize_subcomponents() {
            for (const subcomponent of this.constructor._subcomponents) { 
                // create options
                const subcomponent_options = this._options[subcomponent._component_name] || {};

                // create subcomponent instance
                const subcomponent_instance = new subcomponent(subcomponent_options);

                // add parent and child structure
                subcomponent_instance.parent = this;
                this._subcomponents_instances.push(subcomponent_instance);
                this[subcomponent._component_name] = subcomponent_instance; 
            }

            if (typeof(this._init_) === "function") {
                this._init_();
            }

            const is_ready = await this._is_ready();
            if (is_ready) {
                for (const subcomponent_instance of this._subcomponents_instances) {
                    // initialize subcomponents recursively
                    subcomponent_instance._initialize_subcomponents();
                }
            } 
        }

        _get_event_name (event_name) {
            return this.constructor._component_name + '_' + event_name;
        } 

        /**
         * Wrapper to global events root.on()
         * @param {String} event_name 
         * @param {Function} func 
         */
         _on (event_name, func) {
            const root_node = this._get_root();
            const event_full_name = this._get_event_name(event_name);
            root_node.on.call(root_node, event_full_name, func);
        }

        /**
         * Wrapper to global events root.off()
         * @param {String} event_name 
         * @param {Function} func 
         */
        _off (event_name, func) {
            const root_node = this._get_root();
            const event_full_name = this._get_event_name(event_name);
            root_node.off.call(root_node, event_full_name, func);
        }

        /**
         * Wrapper to global events root.once()
         * @param {String} event_name 
         * @param {Function} func 
         */
        _once (event_name, func) {
            const root_node = this._get_root();
            const event_full_name = this._get_event_name(event_name);
            root_node.once.call(root_node, event_full_name, func); 
        }

        /**
         * Wrapper to global events root.emit()
         * @param {String} event_name 
         * @returns 
         */
        _emit (event_name) {
            if(arguments.length == 0) {
                return;
            }
    
            const root_node = this._get_root();

            const args = [this._get_event_name(event_name)];
    
            for (let i = 1; i < arguments.length; i++) {
                args.push(arguments[i]);
            }
            
            root_node.emit.apply(root_node, args);
        }

        _get_component_name () {
            return this._component_name || 'anonymous_component';
        }

    }


    // /**
    //  * 
    //  *      A
    //  * B        C  D
    //  *        E 
    //  *      F
    //  */
    // $.A = class extends $.ComponentType {
    //     static _component_name = "a";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);
    //         this._initialize_subcomponents();
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready();
    //     }
    // } 

    // $.B = class extends $.ComponentType {
    //     static _component_name = "b";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);  
    //     }

    //     _init_() {
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready();
    //         const root = this._get_root();
    //         root.on("f_ready", () => { console.log("F is ready");});
    //     }
        
    // }

    // $.C = class extends $.ComponentType {
    //     static _component_name = "c";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);
    //     }

    //     _init_() {
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready();
    //     }
    // }

    // $.D = class extends $.ComponentType {
    //     static _component_name = "d";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);
    //     }

    //     _init_() {
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready();
    //     }
    // }

    // $.E = class extends $.ComponentType {
    //     static _component_name = "e";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);
    //     }

    //     _init_() {
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready();
    //     }
    // }

    // $.F = class extends $.ComponentType {
    //     static _component_name = "f";
    //     static _subcomponents = [];

    //     constructor(options) {
    //         super(options);
    //     }

    //     _init_() {
    //         console.log(`called ${this.constructor._component_name} _init_`);
    //         console.dir(this._options);
    //         this._set_ready(); 
    //     }
    // }
    
    // $.A._add_child_component($.B);
    // $.A._add_child_component($.C);
    // $.A._add_child_component($.D);
    // $.C._add_child_component($.E);
    // $.E._add_child_component($.F);

    // window.a = new $.A({ 
    //     b: { is_b: true },
    //     c: {
    //         e: {
    //             is_e: true
    //         },
    //         is_c: true
    //     },
    //     d: {
    //         is_d: true
    //     }, 
    // })

})(ABDOMap);